import { openDb,deleteDb} from 'idb';

const dbName = 'holidays';
export const userInfo = 'userInfo';
export const holidaysForApprove = 'holidaysForApprove';
export const subscription = 'subscribed';
export const myHolidays = 'myHolidays';
export const holidaysForApproveList = 'holidaysForApproveList';
const version = 11;

const dbPromise = openDb(dbName, version, upgradeDB => {
  if (upgradeDB.oldVersion < 2) {
    upgradeDB.createObjectStore(myHolidays, {
      autoIncrement: true,
      unique: true
    });
    upgradeDB.createObjectStore(holidaysForApproveList, {
      autoIncrement: true,
      unique: true
    });
  }
  if (upgradeDB.oldVersion < version) {
    idbMethods.clear(subscription);
  }
  if (!upgradeDB.objectStoreNames.contains(userInfo)) {
    upgradeDB.createObjectStore(userInfo, { keyPath: 'userId' });
  }
  if (!upgradeDB.objectStoreNames.contains(holidaysForApprove)) {
    upgradeDB.createObjectStore(holidaysForApprove, {
      autoIncrement: true,
      unique: true
    });
  } if (!upgradeDB.objectStoreNames.contains(subscription)) {
    upgradeDB.createObjectStore(subscription, {
      autoIncrement: true,
      unique: true
    });
  } if (!upgradeDB.objectStoreNames.contains(myHolidays)) {
    upgradeDB.createObjectStore(myHolidays, {
      autoIncrement: true,
      unique: true
    });
  } if (!upgradeDB.objectStoreNames.contains(holidaysForApproveList)) {
    upgradeDB.createObjectStore(holidaysForApproveList, {
      autoIncrement: true,
      unique: true
    });
  }

});

export const idbMethods = {
  async get(key, objStore) {
    const db = await dbPromise;
    return db.transaction(objStore).objectStore(objStore).get(key);
  },
  async set(val, objStore) {
    const db = await dbPromise;
    const tx = db.transaction(objStore, 'readwrite');
    tx.objectStore(objStore).put(val);
    return tx.complete;
  },
  async setWithKey(val, key, objStore) {
    const db = await dbPromise;
    const tx = db.transaction(objStore, 'readwrite');
    tx.objectStore(objStore).put(val, key);
    return tx.complete;
  },
  async delete(key, objStore) {
    const db = await dbPromise;
    const tx = db.transaction(objStore, 'readwrite');
    tx.objectStore(objStore).delete(key);
    return tx.complete;
  },
  async clear(objStore) {
    const db = await dbPromise;
    const tx = db.transaction(objStore, 'readwrite');
    tx.objectStore(objStore).clear();
    return tx.complete;
  },
  async keys(key, objStore) {
    const db = await dbPromise;
    return db.transaction(objStore).objectStore(objStore).getAllKeys(key);
  },
  async searchByKey(index, key, objStore) {
    const db = await dbPromise;
    return db.transaction(objStore).objectStore(objStore).index(index).getAll(key);
  },
  async getAll(objStore) {
    const db = await dbPromise;
    return db.transaction(objStore).objectStore(objStore).getAll();
  }
};
